"use client";

import React from "react";
import { Star, Phone, MessageCircle } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  author: "Marcus Chen",
  quote: "The outdoor assembly was flawless. Kim and Julio were professional, quick, and left everything spotless. Best service in Sacramento!",
  position: "Land Park Resident • Verified Local"
}, {
  author: "Sarah Jenkins",
  quote: "They assembled my entire IKEA bedroom set in record time. Highly recommend for anyone needing furniture assembly help in Midtown.",
  position: "Midtown Homeowner • Verified Local"
}, {
  author: "David Thompson",
  quote: "Our wood floor treatment looks stunning. The professional polishing and restoration is exactly what we were looking for to bring our floors back to life.",
  position: "Elk Grove Client • Verified Local"
}];
export default function ClientPraise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="30323" id="what-your-neighbors-say" ref={ref} className={cn("relative w-full py-24 overflow-hidden bg-accent transition-opacity duration-1000", isVisible ? "opacity-100" : "opacity-0")}>
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[radial-gradient(circle,var(--color-primary)_0%,transparent_70%)] opacity-10 blur-3xl pointer-events-none" />

      <div className="container relative z-10 mx-auto px-6 md:px-12">
        <Carousel opts={{
        align: "center",
        loop: true
      }} className="w-full max-w-4xl mx-auto">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} className="md:basis-full pl-0">
                <div data-index={i} className="flex flex-col items-center text-center px-4 md:px-16 py-8 bg-card shadow-lg rounded-xl border border-border/50 mx-2">
                  {}
                  <div className="flex gap-1 mb-8">
                    {[...Array(5)].map((_, starIndex) => <Star key={starIndex} className="w-6 h-6 fill-primary text-primary" />)}
                  </div>

                  {}
                  <blockquote className="text-2xl md:text-3xl font-default font-bold text-foreground leading-relaxed mb-8 tracking-tight">
                    &ldquo;{testimonial.quote}&rdquo;
                  </blockquote>

                  {}
                  <div className="space-y-1">
                    <cite className="not-italic text-xl font-default font-extrabold text-foreground block">
                      {testimonial.author}
                    </cite>
                    <span className="text-muted-foreground text-sm font-mono uppercase tracking-widest">
                      {testimonial.position}
                    </span>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="hidden md:block">
            <CarouselPrevious className="border-primary/20 text-primary hover:bg-primary/10 hover:text-primary -left-4 lg:-left-12" />
            <CarouselNext className="border-primary/20 text-primary hover:bg-primary/10 hover:text-primary -right-4 lg:-right-12" />
          </div>
          
          {}
          <div className="flex md:hidden justify-center gap-4 mt-8">
             <CarouselPrevious className="static translate-y-0 translate-x-0 border-primary/20 text-primary hover:bg-primary/10" />
             <CarouselNext className="static translate-y-0 translate-x-0 border-primary/20 text-primary hover:bg-primary/10" />
          </div>
        </Carousel>

        {}
        <div className="mt-20 flex flex-col items-center gap-8 text-center">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full max-w-2xl mx-auto">
            <Button asChild size="lg" className="w-full sm:w-auto h-14 px-10 text-lg font-bold bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg transition-transform hover:-translate-y-1">
              <Link to="tel:+16105498900" className="flex items-center gap-3">
                <Phone className="w-5 h-5 fill-current" />
                Call Now
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto h-14 px-10 text-lg font-bold border-2 border-primary/20 hover:bg-primary/5 transition-transform hover:-translate-y-1">
              <Link to="https://api.whatsapp.com/send?phone=16105498900&text=Hi%20I%20need%20a%20quote" className="flex items-center gap-3">
                <MessageCircle className="w-5 h-5 text-green-600" />
                WhatsApp
              </Link>
            </Button>
          </div>
          <p className="text-muted-foreground font-mono uppercase tracking-widest text-xs">
            Serving Sacramento and surrounding areas
          </p>
        </div>
      </div>
    </section>;
}